<template lang="pug">
yz-filter-menu(label="Expiry date" :is-active="dateFilter.active" :display-value="dateFilter.value" @clear="onClear" @apply="onApply")
  .pa-4
    yz-date-picker(v-model="dateFilter.tempValue" range)
</template>

<script>
export default {
  props: {
    filter: { type: Object, default: () => ({}) },
    checkInitialValue: { type: Boolean, default: false }
  },
  data: () => ({
    dateFilter: {
      active: false,
      value: '',
      tempValue: null
    }
  }),
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) this.clearData()
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue && this.filter.key) {
        this.dateFilter = {
          active: true,
          value: Array.isArray(this.filter.value) ? this.filter.value.join(' - ') : this.filter.value,
          tempValue: this.filter.value
        }
      }
    },
    onClear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.dateFilter = { active: false, value: '', tempValue: null }
    },
    onApply () {
      if (!this.dateFilter.tempValue) return
      this.dateFilter.active = true
      if (Array.isArray(this.dateFilter.tempValue)) {
        this.dateFilter.value = this.dateFilter.tempValue.join(' - ')
      } else {
        this.dateFilter.value = this.dateFilter.tempValue
      }
      this.$emit('update:filter', {
        key: 'expiry_date',
        value: this.dateFilter.tempValue,
        active: this.dateFilter.active
      })
    }
  }
}
</script>
